import React, { useState } from "react";
import MainLayout from 'layouts/mainLayout'
import { Box } from "@mui/material";
import MonitoringReportsMain from "components/Reports/MonitoringReports/MonitoringReportsMain";
const MonitoringReportsPage = () => {
  const [selectedTab, setSelectedTab] = useState("1");
  const [pageState, setPageState] = useState(1);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const monitor = {
    "details": [
      {
        "partnerReportsId": 19545,
        "name": "Monitoring Report_US_01_10_25.json",
        "createdDate": "2025-01-13T14:03:41.439488Z",
        "createdTime": "2025-01-13T14:03:41.439488Z",
        "description": ""
      },
      {
        "partnerReportsId": 19544,
        "name": "Monitoring Report_US_01_10_25.pdf",
        "createdDate": "2025-01-13T14:03:41.428785Z",
        "createdTime": "2025-01-13T14:03:41.428785Z",
        "description": ""
      },
      {
        "partnerReportsId": 19542,
        "name": "Monitoring Report_Canada_01_10_25.json",
        "createdDate": "2025-01-13T14:01:07.503124Z",
        "createdTime": "2025-01-13T14:01:07.503124Z",
        "description": ""
      },
      {
        "partnerReportsId": 19541,
        "name": "Monitoring Report_Canada_01_10_25.pdf",
        "createdDate": "2025-01-13T14:01:07.493552Z",
        "createdTime": "2025-01-13T14:01:07.493552Z",
        "description": ""
      },
      {
        "partnerReportsId": 19526,
        "name": "Monitoring Report_UK_01_01_25.json",
        "createdDate": "2025-01-10T08:37:34.056405Z",
        "createdTime": "2025-01-10T08:37:34.056405Z",
        "description": ""
      },
      {
        "partnerReportsId": 19525,
        "name": "Monitoring Report_Australia_01_01_25.pdf",
        "createdDate": "2025-01-10T08:37:34.018216Z",
        "createdTime": "2025-01-10T08:37:34.018216Z",
        "description": ""
      },
      {
        "partnerReportsId": 19523,
        "name": "Monitoring Report_UK_01_01_25.json",
        "createdDate": "2025-01-10T08:33:21.646032Z",
        "createdTime": "2025-01-10T08:33:21.646032Z",
        "description": ""
      },
      {
        "partnerReportsId": 19522,
        "name": "Monitoring Report_UK_01_01_25.pdf",
        "createdDate": "2025-01-10T08:33:21.634752Z",
        "createdTime": "2025-01-10T08:33:21.634752Z",
        "description": ""
      },
      {
        "partnerReportsId": 19519,
        "name": "Monitoring Report_Australia_01_01_25.json",
        "createdDate": "2025-01-10T08:29:05.514670Z",
        "createdTime": "2025-01-10T08:29:05.514670Z",
        "description": ""
      },
      {
        "partnerReportsId": 19518,
        "name": "Monitoring Report_Australia_01_01_25.pdf",
        "createdDate": "2025-01-10T08:29:05.503745Z",
        "createdTime": "2025-01-10T08:29:05.503745Z",
        "description": ""
      }
    ]
  };

  const compliance = {

    "details": [
      {
        "partnerReportsId": 19572,
        "name": "ComplianceReport_US_25-01-09.json",
        "createdDate": "2025-02-07T11:59:01.923969Z",
        "createdTime": "2025-02-07T11:59:01.923969Z",
        "description": ""
      },
      {
        "partnerReportsId": 19571,
        "name": "ComplianceReport_US_25-01-09.json",
        "createdDate": "2025-02-07T11:15:38.164845Z",
        "createdTime": "2025-02-07T11:15:38.164845Z",
        "description": ""
      },
      {
        "partnerReportsId": 19570,
        "name": "ComplianceReport_US_25-01-08.json",
        "createdDate": "2025-02-07T09:36:23.009520Z",
        "createdTime": "2025-02-07T09:36:23.009520Z",
        "description": ""
      },
      {
        "partnerReportsId": 19546,
        "name": "ComplianceReport_Canada_25-01-10.json",
        "createdDate": "2025-01-13T14:14:25.823498Z",
        "createdTime": "2025-01-13T14:14:25.823498Z",
        "description": ""
      },
      {
        "partnerReportsId": 19543,
        "name": "ComplianceReport_Canada_25-01-10.json",
        "createdDate": "2025-01-13T14:03:39.993776Z",
        "createdTime": "2025-01-13T14:03:39.993776Z",
        "description": ""
      },
      {
        "partnerReportsId": 19540,
        "name": "ComplianceReport_UK_25-01-10.json",
        "createdDate": "2025-01-13T14:01:06.008439Z",
        "createdTime": "2025-01-13T14:01:06.008439Z",
        "description": ""
      },
      {
        "partnerReportsId": 19539,
        "name": "ComplianceReport_UK_25-01-10.json",
        "createdDate": "2025-01-13T13:58:30.374126Z",
        "createdTime": "2025-01-13T13:58:30.374126Z",
        "description": ""
      },
      {
        "partnerReportsId": 19538,
        "name": "ComplianceReport_UK_25-01-10.json",
        "createdDate": "2025-01-13T13:56:24.378452Z",
        "createdTime": "2025-01-13T13:56:24.378452Z",
        "description": ""
      },
      {
        "partnerReportsId": 19537,
        "name": "ComplianceReport_Australia_25-01-10.json",
        "createdDate": "2025-01-13T13:53:58.203826Z",
        "createdTime": "2025-01-13T13:53:58.203826Z",
        "description": ""
      },
      {
        "partnerReportsId": 19536,
        "name": "ComplianceReport_Australia_25-01-10.json",
        "createdDate": "2025-01-13T13:51:17.863795Z",
        "createdTime": "2025-01-13T13:51:17.863795Z",
        "description": ""
      }
    ]
  };

  const historyData = {

    "details": [
      {
        "partnerReportAuditId": 26005,
        "partnerReportsId": 19545,
        "action": "Downloaded",
        "description": "Downloaded on 03-07-2025 05:34:03 AM",
        "createdOn": "2025-03-07T05:34:03.985194Z",
        "createdBy": "SYSTEM"
      },
      {
        "partnerReportAuditId": 25973,
        "partnerReportsId": 19545,
        "action": "Downloaded",
        "description": "Downloaded on 02-27-2025 07:04:57 AM",
        "createdOn": "2025-02-27T07:04:57.141328Z",
        "createdBy": "SYSTEM"
      },
      {
        "partnerReportAuditId": 25972,
        "partnerReportsId": 19545,
        "action": "Downloaded",
        "description": "Downloaded on 02-27-2025 07:04:43 AM",
        "createdOn": "2025-02-27T07:04:43.102138Z",
        "createdBy": "SYSTEM"
      },
      {
        "partnerReportAuditId": 25914,
        "partnerReportsId": 19545,
        "action": "Created ",
        "description": "Created on 01-13-2025 02:03:41 PM",
        "createdOn": "2025-01-13T14:03:41.439488Z",
        "createdBy": "SYSTEM"
      }
    ]
  };

  const pagination = {
    page: pageState,
    count: 1,
    onChange: handlePageChange
  };

  const historyPageNumber = {
    "pageNo": 1
  };

  function handleTabChange(_, newValue) {
    setSelectedTab(newValue);
    setPageState(1);
  }

  function handlePageChange(e, value) {
    setPageState(value);
  }

  function handleHistoryClick(row) {
    setHistoryDialogOpen(true);
    setSelectedRow(row);
  }

  function closeHistoryDialogHandler() {
    setHistoryDialogOpen(false);
    setSelectedRow(null);
  }

  const currentData = selectedTab === "1" ? monitor : compliance;

  return (
    <MainLayout>
      <Box>
        <MonitoringReportsMain
          data={currentData}
          selectedTab={selectedTab}
          pagination={pagination}
          historyData={historyData}
          historyError={null}
          historyDialogOpen={historyDialogOpen}
          reportName={selectedRow?.name}
          historyPageNo={historyPageNumber}
          onChange={handleTabChange}
          onDownload={() => { }}
          onHistoryClick={handleHistoryClick}
          onHistoryPageChange={() => { }}
          closeHistoryDialogHandler={closeHistoryDialogHandler}
        />
      </Box>
    </MainLayout>
  );
};

export default MonitoringReportsPage;